import React from 'react'
// import material ui
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip, IconButton } from '@material-ui/core';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import LinkTo from '../../../_components/LinkTo';
// import router
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    wrapper: {
        paddingTop: 32,
        paddingBottom: 32,
        [theme.breakpoints.down(476)]: {
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    item: {
        display: "flex",
        alignItems: "center",
        gap: 15,
        width: "100%",
        fontSize: 13,
        fontWeight: 600,
        padding: "15px 0",
        "& span": {
            flex: "1 1 auto"
        },
        "&:not(:last-child)": {
            borderBottom: "1px solid #E9EAF3",
        }
    },
    prom: {
        color: "#825CA9",
    },
    csv: {
        color: "#FFBE00",
    },
    xml: {
        color: "#1F1F1F",
    },
    nova_poshta: {
        color: "#FF392B",
    },

    link: {
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        color: "#555F7E",
    },
}));

const DashboardIntegration = (props) => {
    const { data, nova_post_apikey } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    const dynamicIcon = (data, tooltip) => {
        if (data === true) {
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.996 0C3.58 0 0 3.58 0 7.996C0 12.412 3.58 15.9928 7.996 15.9928C12.412 15.9928 15.9928 12.4128 15.9928 7.996C15.992 3.58 12.4128 0 7.996 0ZM1.6 7.996C1.6 7.15607 1.76544 6.32436 2.08687 5.54836C2.4083 4.77236 2.87942 4.06727 3.47335 3.47334C4.06727 2.87942 4.77236 2.4083 5.54836 2.08687C6.32436 1.76544 7.15607 1.6 7.996 1.6C8.83593 1.6 9.66764 1.76544 10.4436 2.08687C11.2196 2.4083 11.9247 2.87942 12.5187 3.47334C13.1126 4.06727 13.5837 4.77236 13.9051 5.54836C14.2266 6.32436 14.392 7.15607 14.392 7.996C14.392 9.69232 13.7181 11.3192 12.5187 12.5187C11.3192 13.7181 9.69232 14.392 7.996 14.392C6.29968 14.392 4.67283 13.7181 3.47335 12.5187C2.27386 11.3192 1.6 9.69232 1.6 7.996ZM11.3656 5.4344C11.5156 5.58442 11.5998 5.78787 11.5998 6C11.5998 6.21213 11.5156 6.41558 11.3656 6.5656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88867 8.41472 4.80804 8.21264 4.80986 8.00288C4.81168 7.79312 4.89582 7.59247 5.04415 7.44415C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L10.2344 5.4344C10.3844 5.28442 10.5879 5.20017 10.8 5.20017C11.0121 5.20017 11.2156 5.28442 11.3656 5.4344Z" fill="#279F51" />
                </svg>
            )
        } else {
            return (
                <Tooltip style={{ padding: 0 }} title={tooltip}>
                    <IconButton>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49306 0.0148544L7.10706 0.0548544C5.23406 0.241854 3.34706 1.20785 2.07106 2.63385C0.660062 4.21085 -0.0569381 6.16785 0.00906191 8.25285C0.124062 11.8539 2.59906 14.9029 6.11006 15.7709C7.14378 16.0205 8.21678 16.0624 9.26682 15.8942C10.3169 15.7259 11.3231 15.3509 12.2271 14.7909C14.0048 13.6832 15.2773 11.9224 15.7711 9.88685C15.9431 9.18585 15.9831 8.82885 15.9831 7.99985C15.9831 7.17085 15.9431 6.81385 15.7711 6.11285C14.9791 2.87785 12.3151 0.497854 9.00006 0.0638544C8.71606 0.0268544 7.68306 -0.00614561 7.49306 0.0148544ZM8.85306 1.56285C9.97634 1.71072 11.0417 2.14879 11.9441 2.83385C12.2731 3.07985 12.9201 3.72685 13.1661 4.05585C13.7271 4.80685 14.1421 5.68985 14.3301 6.53485C14.5441 7.4998 14.5441 8.49991 14.3301 9.46485C13.9161 11.3259 12.6051 12.9779 10.8671 13.8279C10.2405 14.1345 9.57021 14.3423 8.88006 14.4439C8.45606 14.5089 7.54406 14.5089 7.12006 14.4439C5.17206 14.1479 3.52806 13.0849 2.49306 11.4509C2.23848 11.0288 2.02612 10.5826 1.85906 10.1189C1.62087 9.43817 1.5041 8.72094 1.51406 7.99985C1.51406 6.96085 1.71506 6.07485 2.16006 5.15985C2.50006 4.46185 2.84606 3.97985 3.41306 3.41285C3.91457 2.89268 4.50654 2.46809 5.16006 2.15985C6.30509 1.60052 7.59012 1.39278 8.85306 1.56285ZM7.70606 4.28985C7.48206 4.36285 7.35506 4.49085 7.29306 4.70485C7.25706 4.82685 7.25306 5.10585 7.25906 6.81585C7.26706 8.78585 7.26706 8.78685 7.32506 8.89585C7.40126 9.03548 7.52355 9.14434 7.67106 9.20385C7.80306 9.24985 8.19706 9.24985 8.32906 9.20385C8.47657 9.14434 8.59886 9.03548 8.67506 8.89585C8.73306 8.78685 8.73306 8.78585 8.74106 6.81585C8.74906 4.66385 8.74906 4.66185 8.59606 4.48085C8.47206 4.33285 8.33906 4.28385 8.04006 4.27585C7.92854 4.26957 7.81667 4.27426 7.70606 4.28985ZM7.78606 10.5299C7.58599 10.6014 7.41958 10.7447 7.31906 10.9319C7.24687 11.1112 7.23805 11.3098 7.29406 11.4949C7.34813 11.6397 7.4442 11.7652 7.56997 11.8551C7.69574 11.9451 7.84549 11.9955 8.00006 11.9999C8.30306 11.9999 8.61206 11.7799 8.70606 11.4949C8.76207 11.3098 8.75325 11.1112 8.68106 10.9319C8.59828 10.7858 8.47819 10.6643 8.33306 10.5799C8.21706 10.5199 7.90406 10.4909 7.78606 10.5299Z" fill="#FF392B" />
                        </svg >
                    </IconButton>
                </Tooltip>
            )
        }
    }

    return (
        <div className={`dashboard-card ${classes.wrapper}`}>
            <h2 className="dashboard-title">{t('common:integration_label')}</h2>
            {data[0] && (
                <div className={classes.item}>
                    {dynamicIcon(data[0]?.prom_unloading, t('common:lack_of_integration_label'))}
                    <span className={classes.prom}>{t('common:url_prom')}</span>
                    <Link className={classes.link} to={"/dashboard/integration/xml"}>{data[0]?.prom_unloading ? t('common:read_mode_label') : t("common:get_label")} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668" stroke="#555F7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg></Link>
                </div>
            )}
            {data[1] && (
                <div className={classes.item}>
                    {dynamicIcon(data[1]?.csv_unloading, t('common:lack_of_integration_label'))}
                    <span className={classes.csv}>{t('common:url_csv')}</span>
                    <Link className={classes.link} to={"/dashboard/integration/csv"}>{data[1]?.csv_unloading ? t('common:read_mode_label') : t("common:get_label")} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668" stroke="#555F7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg></Link>
                </div>
            )}
            {data[2] && (
                <div className={classes.item}>
                    {dynamicIcon(data[2]?.json_unloading, t('common:lack_of_integration_label'))}
                    <span className={classes.xml}>{t('common:url_integration')}</span>
                    <Link className={classes.link} to={"/dashboard/integration/json"}>{data[2]?.json_unloading ? t('common:read_mode_label') : t("common:get_label")} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668" stroke="#555F7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg></Link>
                </div>
            )}
            {nova_post_apikey ? (
                <div className={classes.item}>
                    {dynamicIcon(nova_post_apikey?.is_expired, t('common:key_not_active_label'))}
                    <span className={classes.nova_poshta}>Нова Пошта</span>
                    <Link className={classes.link} to={"/dashboard/integration/nova-poshta"}>{!nova_post_apikey?.is_expired ? t("common:get_label") : t('common:read_mode_label')} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668" stroke="#555F7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg></Link>
                </div>
            ) : null}
        </div>
    )
}

export default DashboardIntegration